import register from 'preact-custom-element'
import { useEffect, useRef, useState } from 'preact/hooks'
import CarouseCustom from 'snippets/carousel-custom/carousel-custom'
import { fetchData } from 'helpers/global'
import { getProductTitle } from 'uses/useShopify'
import PlpCard from 'snippets/plp-card/plp-card'
import { elInViewPort } from 'helpers/dom'
import throttle from 'lodash.throttle'
import { getBoxContains } from 'uses/useSearchspringUtils'

function ProductRecipe({ title, handles }) {
  const elRef = useRef(null)
  const dataProducts = handles.split('|')
  const [products, setProducts] = useState([])

  const fetchProducts = async (handles) => {
    const allFetchs = handles.map((handle) => {
      return fetchData(`/products/${handle}?view=ajax`).then((product) => {
        return product
      })
    })
    return Promise.all(allFetchs).then((results) => results)
  }

  const init = async (dataProducts) => {
    const products = await fetchProducts(dataProducts)
    if (products.length) {
      setProducts(products)
    }
  }

  const handleInit = () => {
    if (elInViewPort(elRef.current)) {
      init(dataProducts)
      window.removeEventListener('scroll', onInit)
    }
  }

  const onInit = throttle(handleInit, 500)

  useEffect(() => {
    if (dataProducts.length > 0) {
      window.addEventListener('scroll', onInit)
    }
  }, [])

  return (
    dataProducts.length > 0 && (
      <div className="relative -mt-px border-t" ref={elRef}>
        <div className="flex flex-col">
          { title && (
            <div className="container">
              <h3 className="text-2xl font-bold py-4 md:text-center md:py-8 md:text-3xl z-[1] text-grey-900">{title}</h3>
            </div>
          )}
          {products.length > 0 && (
            <div>
              <CarouseCustom classWrap="border-t" content={<ProductRecipeItems products={products} />} />
            </div>
          )}
        </div>
      </div>
    )
  )
}

function ProductRecipeItems({ products }) {
  return products.map((product) => {
    const metafields = getBoxContains(product, 'ajax')
    return (
      <PlpCard
        className="flex flex-col flex-shrink-0 w-1/2 p-4 border-r lg:pb-8 sm:w-1/3 lg:w-1/4 snap-start border-default lg:relative lg:overflow-hidden carousel-item"
        title={getProductTitle(product.variants.length === 1, product.title, product.variants[0].weight, product.variants_data[product.initVariant.id].weight_unit)}
        subtitle={product.title}
        handle={product.handle}
        suffix={product.template_suffix}
        url={product.url}
        imageUrl={[product.featuredImage]}
        secondImageUrl={product.images}
        available={product.available}
        variants={product.variants}
        options={product.options}
        tags={product.tags}
        metafields={metafields}
      />)
  })
}

register(ProductRecipe, 'product-recipe', ['title', 'handles'])
